import { render, staticRenderFns } from "./tag-edit-modal.vue?vue&type=template&id=18587178&scoped=true&"
import script from "./tag-edit-modal.vue?vue&type=script&lang=js&"
export * from "./tag-edit-modal.vue?vue&type=script&lang=js&"
import style0 from "./tag-edit-modal.vue?vue&type=style&index=0&id=18587178&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18587178",
  null
  
)

export default component.exports